import React from 'react';
import './FollowModal.css';
import { FaLinkedin, FaInstagram, FaTimes } from 'react-icons/fa';

const FollowModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>
                    <FaTimes />
                </button>

                <h2 className="modal-title">Follow Me</h2>
                <p className="modal-subtitle">Connect with me on social media!</p>

                <div className="social-links">
                    <a
                        href="https://linkedin.com/in/divyesh-thirukonda/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link linkedin"
                    >
                        <FaLinkedin size={24} />
                        <div className="social-info">
                            <div className="social-name">LinkedIn</div>
                            <div className="social-handle">@divyesh-thirukonda</div>
                        </div>
                    </a>

                    <a
                        href="https://instagram.com/divyesh_thirukonda/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link instagram"
                    >
                        <FaInstagram size={24} />
                        <div className="social-info">
                            <div className="social-name">Instagram</div>
                            <div className="social-handle">@divyesh_thirukonda</div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default FollowModal;
